export default {"src":"/_next/static/media/img-landing-hero-bg-4.408064e0.svg","height":512,"width":530,"blurWidth":0,"blurHeight":0};